import TemplateView from "../../../TemplateView"
import TaskCard from "./TaskCard"
import SortableListContainer from "../../../components/SortableListContainer"
import {getColorClassById, getStatusClassByType} from "../../../workflowStatus/utils"
import {isArraysWithIdsItemsOrderEqual} from "../../../atUtils"
import {WorkflowStatusType} from '../../../workflowStatus/constants'

export default class TasksColumn extends TemplateView {
    constructor({
        props = {
            projectId: null,
            workflowStatus: null,
            emptyColumnText: "",
            canDrop: true,
        },
        onTaskDragging = () => {},
        onTaskDragStart = () => {},
        onTaskDragStop = () => {},
        onTaskDragOver = () => {},
        onTaskDragOut = () => {},
        onTaskPositionChanged = () => {},
        onTaskAdded = () => {},
        onTaskRemoved = () => {},
        onTaskClick = taskId => {},
        onTaskSelectChanged = () => {},
        onCardActiveSelectionDisappear = () => {},
    }) {
        super()

        this.state = {
            tasks: [],
            minimizedCards: false,
            selectedTaskIds: {},
            taskIdWithDetailsOpen: null,
            lastCreatedTaskIds: {},
            recentlyCreatedTaskIds: {},
            canDrop: false,
            updatingTaskIds: {},
            showSelection: false,
            showEstimate: false,

            needRefreshSortable: false,
        }

        this.props = props

        this.nodes = {}

        this.callbacks = {
            onTaskDragging,
            onTaskDragStart,
            onTaskDragStop,
            onTaskDragOver,
            onTaskDragOut,
            onTaskPositionChanged,
            onTaskAdded,
            onTaskRemoved,
            onTaskClick,
            onTaskSelectChanged,
            onCardActiveSelectionDisappear,
        }

        this.onStatePropertyChanged('tasks', (tasks, prevStateTasks) => {
            this.getEl().toggleClass("empty", tasks.length === 0)
            if (!isArraysWithIdsItemsOrderEqual(tasks, prevStateTasks)) {
                this.sortableTaskCardList.setState({items: tasks})
            } else {
                this._updateTaskCards(tasks)
            }
        })

        this.onStatePropertyChanged('canDrop', canDrop => this.sortableTaskCardList.setState({canDrop}))
        this.onAnyStatePropertyChanged(
            [
                'selectedTaskIds',
                'taskIdWithDetailsOpen',
                'recentlyCreatedTaskIds',
                'updatingTaskIds',
                'showSelection',
                'showEstimate',
                'lastCreatedTaskIds',
            ],
            () => this._updateTaskCards())

        this.onStatePropertyChanged('minimizedCards', (minimizedCards) => {
            this._updateTaskCards()
            this.sortableTaskCardList.setState({
                additionalPlaceholderClass: minimizedCards ? 'minimized' : ''
            })
        })

        this.onStatePropertyBecameTrue("needRefreshSortable", needRefreshSortable => {
            this.sortableTaskCardList.setState({needRefreshSortable})
            this.setStateInternal({needRefreshSortable: false})
        })
    }

    templateHtml() {
        return "<div class='tasksColumn <%=colorClass%>'></div>"
    }

    templateModel() {
        let colorClass = getColorClassById(this.props.workflowStatus.colorId)
        if (this.props.workflowStatus.type === WorkflowStatusType.OPEN) {
            colorClass += " " + getStatusClassByType(WorkflowStatusType.OPEN)
        } else if (this.props.workflowStatus.type === WorkflowStatusType.COMPLETED) {
            colorClass += " " + getStatusClassByType(WorkflowStatusType.COMPLETED)
        }
        return {
            colorClass: colorClass,
            emptyColumnText: this.props.emptyColumnText
        }
    }

    afterRender() {
        const taskCardRenderer = (task) => {
            const node = new TaskCard({
                onClick: () => this.callbacks.onTaskClick(task.id),
                onChangeSelect: (selected) => {
                    this.callbacks.onTaskSelectChanged(task.id, selected)
                },
                onCardActiveSelectionDisappear: () => this.callbacks.onCardActiveSelectionDisappear(task.id),
            })
            this.nodes[task.id] = node
            this._setTaskCardState(task)
            return node
        }

        this.sortableTaskCardList = new SortableListContainer({
            itemRenderer: taskCardRenderer,
            placeholderText: this.props.workflowStatus.name,
            sortableConfig: {
                tolerance: 'intersect',
                cloneItem: true,
                connectWithClass: 'tasksColumn'
            },
            onItemDragStart: this.callbacks.onTaskDragStart,
            onItemDragStop: this.callbacks.onTaskDragStop,
            onPositionChangedCb: ({id, precedingId}) => {
                this.callbacks.onTaskPositionChanged({
                    workflowStatusId: this.props.workflowStatus.id,
                    taskId: id,
                    precedingTaskId: precedingId
                })
            },
            onItemReceiveCb: ({itemIndex}) => {
                const lastIndex = this.state.tasks.length - 1;
                const precedingTaskId = itemIndex === 0 || lastIndex === -1 ? null : itemIndex > lastIndex ? this.state.tasks[lastIndex].id : this.state.tasks[itemIndex - 1].id;
                this.callbacks.onTaskAdded({
                    workflowStatusId: this.props.workflowStatus.id,
                    precedingTaskId: precedingTaskId
                })
            },
            onItemRemoveCb: this.callbacks.onTaskRemoved,
            onDragOver: () => {
                this.callbacks.onTaskDragOver(this.state.canDrop, this.props.workflowStatus)
            },
            onDragOut: () => {
                this.callbacks.onTaskDragOut()
            },
            onItemDragging: this.callbacks.onTaskDragging
        }).init(this.getEl())
    }

    _updateTaskCards() {
        this.getEl().toggleClass('minimized', this.state.minimizedCards)
        this.state.tasks.forEach(task => {
            this._setTaskCardState(task)
        })
    }

    _setTaskCardState(task) {
        this.nodes[task.id].setState({
            name: task.name,
            highlightedName: task.highlightedName,
            spentTime: task.spentTime,
            estimatedTime: task.estimatedTime,
            commentsNumber: task.commentsNumber,
            colorId: this.props.workflowStatus.colorId,
            disabled: this.state.updatingTaskIds[task.id] === true,
            selected: !!this.state.selectedTaskIds[task.id],
            minimized: this.state.minimizedCards,
            detailsOpen: this.state.taskIdWithDetailsOpen === task.id,
            isLastCreatedTask: !!this.state.lastCreatedTaskIds[task.id],
            recentlyCreated: !!this.state.recentlyCreatedTaskIds[task.id],
            selectable: this.state.showSelection,
            showEstimate: this.state.showEstimate,
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/kanban/components/TasksColumn.js